export const platformOptions = {
  power_center: 'power_center',
  final_surge: 'final_surge',
  two_peak: '2_peak',
  training_peaks: 'training_peaks',
};
